// src/pages/Medicines/medicinesTourConfig.js

export const medicinesTourSteps = [
    {
        popover: {
            title: '👋 Bienvenue sur votre Page Médicaments',
            description: 'Je vais vous guider à travers toutes les fonctionnalités pour gérer vos médicaments et prescriptions.',
            side: 'over',
        },
    },
    {
        element: '.meds-section',
        popover: {
            title: '💊 Page Médicaments',
            description: 'Cette page vous permet de gérer vos prescriptions, suivre vos médicaments actifs et consulter votre historique complet.',
            position: 'center',
        },
    },
    {
        element: '.meds-left',
        popover: {
            title: '📋 Zone Principale',
            description: 'La zone principale contient vos prescriptions et votre liste de médicaments avec un calendrier de suivi.',
            position: 'right',
        },
    },
    {
        element: '.rx-card',
        popover: {
            title: '📄 Carte de Prescription',
            description: 'Gérez vos prescriptions médicales ici. Vous pouvez ajouter une nouvelle prescription ou un médicament.',
            position: 'bottom',
        },
    },
    {
        element: '.rx-banner',
        popover: {
            title: '🔔 Notification',
            description: 'Vous recevrez des notifications ici lorsque votre médecin vous envoie une nouvelle prescription.',
            position: 'bottom',
        },
    },
    {
        element: '.rx-banner-cta',
        popover: {
            title: '👀 Voir Maintenant',
            description: 'Cliquez sur "See now" pour consulter immédiatement la nouvelle prescription envoyée par votre médecin.',
            position: 'left',
        },
    },
    {
        element: '.rx-drop',
        popover: {
            title: '📁 Zone de Dépôt',
            description: 'Glissez-déposez un fichier de prescription (PDF, image) ici ou cliquez pour sélectionner un fichier depuis votre ordinateur.',
            position: 'right',
        },
    },
    {
        element: '.rx-info',
        popover: {
            title: '📝 Informations',
            description: 'Section d\'informations avec les actions disponibles pour ajouter des prescriptions ou médicaments.',
            position: 'left',
        },
    },
    {
        element: '.rx-btn-primary',
        popover: {
            title: '➕ Ajouter une Prescription',
            description: 'Cliquez ici pour ajouter une nouvelle prescription complète à votre dossier médical.',
            position: 'bottom',
        },
    },
    {
        element: '.rx-btn-ghost',
        popover: {
            title: '💊 Ajouter un Médicament',
            description: 'Ajoutez directement un médicament à votre liste sans passer par une prescription formelle.',
            position: 'bottom',
        },
    },
    {
        element: '.medication-list-card',
        popover: {
            title: '📅 Liste de Médicaments',
            description: 'Votre liste complète de médicaments actifs avec un calendrier hebdomadaire pour suivre vos prises.',
            position: 'top',
        },
    },
    {
        element: '.meds-right',
        popover: {
            title: '📊 Barre Latérale',
            description: 'La barre latérale droite contient votre historique complet de médicaments et prescriptions.',
            position: 'left',
        },
    },
    {
        element: '.mhc-card',
        popover: {
            title: '🕐 Historique de Médicaments',
            description: 'Consultez l\'historique complet de toutes vos prescriptions passées et actuelles en un seul endroit.',
            position: 'left',
        },
    },

    {
        element: '.mhc-search',
        popover: {
            title: '🔍 Rechercher',
            description: 'Utilisez la barre de recherche pour trouver rapidement un médicament spécifique dans votre historique.',
            position: 'bottom',
        },
    },
    {
        element: '.mhc-list',
        popover: {
            title: '📜 Liste de l\'Historique',
            description: 'Tous vos médicaments avec leur dosage, date de début et statut (En cours, Complété, Manqué).',
            position: 'top',
        },
    },
    {
        popover: {
            title: '🎉 Tour Terminé !',
            description: 'Vous savez maintenant comment gérer vos médicaments et prescriptions. N\'oubliez pas de prendre vos médicaments à l\'heure !',
            side: 'over',
        },
    },
];